import { ReactNode, forwardRef, ForwardedRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Merge } from 'src/utils/types'

export interface CoreInputAreaProps {
  id: string
  label?: string
  icon?: ReactNode
  className?: string | undefined
  variant?: 'standard' | 'primary' | 'secondary'
  error?: string
}

export type InputAreaProps = Merge<
  React.ComponentProps<'textarea'>,
  CoreInputAreaProps
>

export const InputArea = forwardRef(function Input(
  props: InputAreaProps,
  ref: ForwardedRef<HTMLTextAreaElement>
) {
  const {
    id,
    label,
    icon,
    className,
    error = false,
    variant,
    ...inputProps
  } = props
  return (
    <div>
      <div className='relative text-left'>
        {icon && (
          <div
            className={twMerge(
              'absolute top-1 left-1',
              variant === 'standard' && 'text-gray-800',
              error && 'text-red'
            )}
          >
            {icon}
          </div>
        )}
        {label && (
          <label
            htmlFor={id}
            className={twMerge(
              'text-black font-bold m-0 ml-0.5 mb-0.5',
              error && 'text-red'
            )}
          >
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          {...inputProps}
          value={inputProps.value}
          className={twMerge(
            'w-full p-2  min-h-text-area',
            icon && 'pl-8',
            variant === 'standard' &&
            'text-gray-900 border-0 border-b border-b-gray-600 focus:ring-0 focus:border-b-gray-900',
            variant === 'primary' &&
            'bg-white border border-gray-600 text-black focus:border-blue focus:border-2 focus:ring-blue',
            variant === 'secondary' &&
            'bg-gray-400 border border-gray-600 text-black rounded-lg focus:border-blue focus:border-2 focus:ring-blue',
            error &&
            variant === 'standard' &&
            'border-red placeholder:text-red',
            error &&
            variant === 'primary' &&
            'focus:border-red focus:border-2 focus:ring-red',
            className
          )}
        />
      </div>
      <div className='text-sm'>{error}</div>
    </div>
  )
})

export default InputArea
